export default __webpack_public_path__ + "static/media/logo-footer.3de46a6a.png";